<template>
    <dialog-modal
        v-if="
            shouldRender && hasAnyPermission(['owner.create', 'owner.update'])
        "
        :closeable="true"
        :is-processing="form.processing"
        :primary-button-label="
            !owner ? trans('general.action.add') : trans('general.action.save')
        "
        :show="show"
        :submit-disabled="!form.isDirty"
        @close="close"
        @submit="submitForm"
    >
        <template #title>{{ title }}</template>

        <form @submit.prevent="submitForm">
            <jet-input
                v-model="form.name"
                :autofocus="true"
                :horizontal="{ label: 'col-sm-4', input: 'col-sm-8' }"
                :invalidFeedback="form.errors.name"
                :label="trans('owners.form.name.label')"
                :placeholder="trans('owners.form.name.placeholder')"
                :required="true"
            />
            <row>
                <column sm="4"
                    >{{ trans('owners.form.contact_details.label') }}
                </column>
                <column sm="8">
                    <jet-input
                        v-model="form.email"
                        :horizontal="false"
                        :invalidFeedback="form.errors.email"
                        :label="trans('stakeholders.form.email.label')"
                        :placeholder="
                            trans('stakeholders.form.email.placeholder')
                        "
                        :required="true"
                    />
                    <jet-input
                        v-model="form.description"
                        :horizontal="false"
                        :invalidFeedback="form.errors.description"
                        :label="trans('stakeholders.form.description.label')"
                        :placeholder="
                            trans('stakeholders.form.description.placeholder')
                        "
                        class="mb-0"
                    />
                </column>
            </row>
        </form>
        <required-fields />
    </dialog-modal>
</template>

<script>
import JetInput from '@/Jetstream/Input.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetSelect from '@/Jetstream/Select.vue';
import DialogModal from '@/Jetstream/DialogModal.vue';
import FileUpload from '@/Components/FileUpload.vue';
import { eventBus, events } from '@/eventBus.js';
import RequiredFields from '@/Components/RequiredFields.vue';
import { $http } from '@/bootstrap.js';

export default {
    name: 'UpdateOrCreateOwnerFormModal',
    emits: ['created', 'updated'],
    components: {
        RequiredFields,
        FileUpload,
        DialogModal,
        JetButton,
        JetInput,
        JetSelect,
    },
    data() {
        return {
            shouldRender: false,
            show: false,
            isLoading: false,
            owner: null,
            form: this.$inertia.form({
                name: '',
                email: '',
                description: '',
            }),
        };
    },
    mounted() {
        eventBus.$on(
            [events.openCreateOwnerModal, events.openEditOwnerModal],
            (data) => {
                this.owner = data?.owner || null;
                this.reset();

                if (this.owner) {
                    this.loadOwnerInformation();
                }

                this.shouldRender = true;
                this.$nextTick(() => {
                    this.show = true;
                });
            },
        );
    },
    beforeUnmount() {
        eventBus.$off([events.openCreateOwnerModal, events.openEditOwnerModal]);
    },
    computed: {
        title() {
            return !!this.owner
                ? this.trans('owners.edit.title')
                : this.trans('owners.create.title');
        },
    },
    methods: {
        submitForm() {
            let route = this.owner
                ? this.route('owners.update', {
                      owner: this.owner,
                  })
                : this.route('owners.store');

            this.form
                .transform((data) => {
                    if (this.owner) {
                        data._method = 'PUT';
                    }
                    return data;
                })
                .post(route, {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.close();

                        this.$emit(
                            this.owner ? 'updated' : 'created',
                            this.owner,
                        );
                    },
                });
        },
        close() {
            this.show = false;
            setTimeout(() => {
                this.shouldRender = false;
            }, 300);
        },
        loadOwnerInformation() {
            this.isLoading = true;
            $http
                .get(this.route('owners.edit', this.owner))
                .then((response) => {
                    this.owner = response.data.owner;
                    this.form = this.$inertia.form({
                        name: this.owner?.name || '',
                        email: this.owner?.email || '',
                        description: this.owner?.description || '',
                    });
                })
                .finally(() => (this.isLoading = false));
        },
        reset() {
            this.form = this.$inertia.form({
                name: this.owner?.name || '',
                email: this.owner?.email || '',
                description: this.owner?.description || '',
            });
        },
    },
};
</script>
